/**
 * AddLiveEventCtrl controller
 * Add/edit LiveEvent
 */

import {
  DRM_ACCOUNT_TYPES,
  LIVE_REWIND_OPTIONS,
  PLATFORM_TYPES, RESOLUTIONS,
  STREAMING_PROVIDER_TYPES,
  URL_PATTERN
} from 'app/core/constants'
import { getId } from '../../app/helpers/entity'
import { formatDateByTimezone, timeStringToDate } from '../../app/helpers/date'
import { openAssignContentSets } from '../common/directives/contentItems/ci.directives'

// controller mixins
AddLiveEventCtrl.mixes = [
  ['m2mCtrlMixin', 'le', 'networks']
]

/**
 * AddLiveEventCtrl controller
 *
 * @class AddLiveEventCtrl
 * @memberof mwApp/liveEvents
 * @see mwApp/liveEvents
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/liveEvents.controller:AddLiveEventCtrl
 */
/* @ngInject */
export default function AddLiveEventCtrl ($timeout, $state, $scope, $transition$, $location, $uibModal, LiveEvent, LiveEventSet, Network, le, extra, authSvc, alertSvc, alertLiteSvc, allNetworksById) {
  const vm = this
  Object.assign(vm, extra)

  vm.urlPattern = URL_PATTERN
  vm.resolutions = RESOLUTIONS

  /**
   * Live Rewind Options
   *
   * @memberOf mwApp/addLiveEvent.controller:AddLiveEventCtrl
   * @type {Object}
   */
  vm.live_rewind_options = LIVE_REWIND_OPTIONS
  vm.liveRewindOptions = Object.keys(LIVE_REWIND_OPTIONS)

  /**
   * LiveEvents
   *
   * @memberof mwApp/liveEvents.controller:AddLiveEventCtrl
   * @type {models.LiveEvent}
   */
  vm.le = le

  // hack for always displaying tooltip
  vm.showTooltip = true

  vm.showSimpleCheckbox = !vm.le.catchup || (vm.le.catchup && !vm.le.catchup.enabled)

  /**
   * isNew flag
   *
   * @memberof mwApp/liveEvents.controller:AddLiveEventCtrl
   * @type {Boolean}
   */
  vm.isNew = le._isNew()
  if (!vm.isNew && le.networks.length === 0) {
    vm.networkSelected = { id: 0, name: 'All Organizations' }
  }

  if (!vm.isNew) {
    le.contentSets.forEach(cs => { cs.networkName = allNetworksById[cs.networkId]?.name })
  }

  /**
   * AuthSvc service
   *
   * @memberof mwApp/liveEvents.controller:AddLiveEventCtrl
   * @type {AuthSvc}
   */
  vm.authSvc = authSvc

  /**
   * DRM account types
   *
   * @memberOf mwApp/channels.controller:AddChannelCtrl
   * @type {Object}
   */
  vm.drm_account_types = DRM_ACCOUNT_TYPES

  /**
   * Platform types
   *
   * @memberof mwApp/liveEvents.controller:AddLiveEventCtrl
   * @type {Object[]}
   */
  vm.platformTypes = angular.copy(PLATFORM_TYPES.filter((p) => {
    return !(!authSvc.hasEnabledFlag('WEB_PLATFORM_ENABLED') && p.value === 'WEB')
  }))

  /**
   * Networks sets
   *
   * @memberof mwApp/liveEvents.controller:AddLiveEventCtrl
   * @type {Array}
   */
  vm.networksSets = []

  /**
   * Streaming Provider types
   *
   * @memberof mwApp/liveEvents.controller:AddLiveEventCtrl
   * @type {Object}
   */
  vm.streaming_provider_types = STREAMING_PROVIDER_TYPES
  vm.lr_streaming_provider_types = { ...STREAMING_PROVIDER_TYPES }
  delete vm.lr_streaming_provider_types.WOWZA
  delete vm.lr_streaming_provider_types.AKAMAI_V2

  /**
   * Upload logo
   *
   * @memberof mwApp/liveEvents.controller:AddLiveEventCtrl
   * @function
   */
  function uploadLogo (file, type) {
    return le._uploadFile(null, file, {
      type
    }).data()
  }

  /**
   * Validate, if at least one platform is checked
   *
   * @memberof mwApp/liveEvents.controller:AddLiveEventCtrl
   */
  vm.atLeastOnePlatform = function () {
    for (let i = vm.platformTypes.length; i--;) {
      if (vm.platformTypes[i].checked) {
        return false
      }
    }
    return true
  }

  le.urls = le.urls || {}

  // // load extra
  vm.listOfNetworks = angular.copy(vm.networks)
  if (!vm.isNew && le.networks.length === 0) {
    le.networks = vm.networks
    vm.networks = [{ id: -1, name: 'Deselect all Organization' }]
  } else {
    const existingNetworks = le.networks.map(getId)
    vm.networks = [{ id: 0, name: 'All Organizations' }].concat(vm.networks.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)))
      .filter(n => existingNetworks.indexOf(n.id) === -1)
  }

  /**
   * ! Need refactoring START !
   */

  vm.language = []
  vm.searchParams = {
    language: null,
    countryForAR: null,
    title: '',
    adult: false
  }

  vm.getRating = function () {
    if (vm.le.$ageRatingType === 'default') {
      return vm.le.$ageRatings.defaultAgeRatings
    } else {
      if (vm.le.$country) {
        return vm.le.$ageRatings.customAgeRatings.find(r => r.id === vm.le.$country.id).ageRatings
      }
    }
  }

  if (vm.le.$countries.length) {
    vm.searchParams.countryForAR = vm.le.$countries.find(c => c.isoCode === 'GB')
  }

  if (!vm.isNew && le.$ageRating) {
    if (vm.le.$ageRatingType === 'default') {
      vm.le.$defaultAgeRating = vm.le.$ageRatings.defaultAgeRatings.find(r => r.id === le.$defaultAgeRating.id)
      vm.le.$ageRating = null
    } else {
      vm.le.$country = vm.le.$countries.find(c => c.id === le.$country.id)
      const country = vm.le.$ageRatings.customAgeRatings.find(c => c.id === le.$country.id)
      vm.le.$ageRating = country.ageRatings.find(r => r.id === vm.le.$ageRating.id)
      vm.le.$defaultAgeRating = null
    }
  }

  /**
   * ! Need refactoring END !
   */

  /**
   * Create/update Live Event
   *
   * @memberof mwApp/liveEvents.controller:AddLiveEventCtrl
   */

  vm.lengthError = false
  vm.save = function (form) {
    for (const control of form.$$controls) {
      control.$setDirty()
      control.$validate()
    }
    if (vm.isNew) {
      vm.dpCfgED.changeHandler(form)
    }
    if (!vm.le.publishTime) {
      if (vm.le.$scheduledPublishing) {
        vm.dpCfg.changeHandler(form)
      }
    }

    if (form.$invalid) {
      return
    }

    // validation for posters
    if (!vm.le.verticalPosterUrl || !vm.le.videoPosterUrl) {
      return
    }

    vm.setDisable()

    le._save(le => {
      if (le.networks.length === vm.listOfNetworks.length) {
        le.networks = []
      }
    })
      .then(vm.location(le).reload)
      .then(
        () => {
          if (vm.isNew && authSvc.hasAccess('editLiveEvent')) {
            LiveEvent.loadAvailableContentSets(le)
              .then(data => {
                if (data.length) {
                  alertSvc.confirm(`${le.name} Live Event has added. <br> Do You want to assign this Live Event to the Live Event Set(s)?`)
                    .then(() => {
                      openAssignContentSets($state, $location, le, true)
                    })
                }
              })
          }
        })
      .catch(vm.unsetDisable)
  }

  /**
   * Disable not enable items
   * @param item
   * @returns {boolean}
   */
  vm.disableChoice = (item) => {
    return !item.enabled
  }

  /**
   * Delete Live Event
   *
   * @memberof mwApp/liveEvents.controller:AddLiveEventCtrl
   */
  vm.delete = function () {
    if (vm.isEpisode) {
      return
    }

    vm.setDisable()
    le._delete()
      .then(vm.location(le).list)
      .catch(vm.unsetDisable)
  }

  /**
   * Upload Portrait logo
   *
   * @memberof mwApp/liveEvents.controller:AddLiveEventCtrl
   * @function
   */
  vm.uploadVerticalPoster = (file) => {
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      const widthPart = this.width / 2
      const heightPart = this.height / 3
      _URL.revokeObjectURL(objectUrl)

      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (widthPart / heightPart < 0.98 || widthPart / heightPart > 1.02) {
        alertLiteSvc.alertError('Vertical poster aspect ratio must be 2:3')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return uploadLogo(file, 'vertical_live_event')
        .then((url) => {
          vm.le.verticalPosterUrl = url
        })
        .finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
    vm.form.$setDirty()
  }

  /**
   * Upload Background logo
   *
   * @memberof mwApp/liveEvents.controller:AddLiveEventCtrl
   * @function
   */
  vm.uploadVideoPoster = (file) => {
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      const widthPart = this.width / 16
      const heightPart = this.height / 9
      _URL.revokeObjectURL(objectUrl)
      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (widthPart / heightPart < 0.98 || widthPart / heightPart > 1.02) {
        alertLiteSvc.alertError('Video poster aspect ratio must be 16:9')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return uploadLogo(file, 'video_live_event')
        .then((url) => {
          vm.le.videoPosterUrl = url
        }).finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
    vm.form.$setDirty()
  }

  /**
   * Find provider type by platformName from selected profiles
   * @param platformName
   * @returns {Function}
   */
  vm.findSelectedProviderType = (platformName) => {
    const selectedProfile = vm.le?.urls[platformName]?.drmProfiles && vm.le.urls[platformName].drmProfiles[0]
    if (!selectedProfile) {
      return null
    }

    return selectedProfile.providerType
  }

  /**
   *  Filter for drm profiles
   * @param platformName
   * @returns {Function}
   */
  $scope.filterProfiles = function (platformName) {
    return function (profile) {
      if (!vm.le.urls[platformName] ||
        !vm.le.urls[platformName].drmProfiles ||
        !vm.le.urls[platformName].drmProfiles.length) {
        return true
      }

      const selectedProviderType = vm.findSelectedProviderType(platformName)
      return profile.providerType === selectedProviderType && !vm.le.urls[platformName].drmProfiles.find((p) => p.drmType === profile.drmType)
    }
  }

  /**
   * Change Publish Now
   *
   * @memberof mwApp/liveEvents.controller:AddLiveEventCtrl
   */
  vm.handleChangePublish = function () {
    if (vm.le.enabled) {
      vm.le.$scheduledPublishing = false
      vm.le.$fromDate = new Date()
      vm.le.$fromTime = timeStringToDate(null, 'startOfDay')
      vm.le.$toDateUnlimited = true
    } else {
      if (vm.le.catchup) { vm.le.catchup.enabled = false }
      if (vm.le.liveRewind) { vm.le.liveRewind.enabled = false }
      vm.showSimpleCheckbox = true
    }
  }

  /**
   * Change Scheduled Publishing
   *
   * @memberof mwApp/liveEvents.controller:AddLiveEventCtrl
   */
  vm.handleChangeScheduled = function () {
    if (vm.le.$scheduledPublishing) {
      vm.le.enabled = false
    }
  }

  /**
   * "From" datepicker settings
   *
   * @memberof mwApp/shows.controller:AddLiveEventCtrl
   */
  vm.dpCfg = {
    format: 'dd.MM.yyyy',
    minDate: new Date(),
    changeHandler: function (form, field = null) {
      if (field) {
        form[field].$setTouched()
      } else {
        form.dateFrom.$setTouched()
        form.dateTo.$setTouched()
      }
      const fromDate = vm.le.$fromDate && vm.le.$fromDate?.setHours(vm.le.$fromTime.getHours(), vm.le.$fromTime.getMinutes())
      const toDate = vm.le.$toDate && vm.le.$toDate?.setHours(vm.le.$toTime.getHours(), vm.le.$toTime.getMinutes())
      const minDateStart = fromDate > formatDateByTimezone(Date.now(), false).valueOf()
      const minDateEnd = toDate > formatDateByTimezone(Date.now(), false).valueOf()
      if (field === 'dateFrom' || !field) {
        form.dateFrom.$setValidity('minDate', minDateStart)
        form.dateFrom.$setValidity('after', true)

        if (fromDate && toDate) {
          const after = toDate > fromDate
          if (vm.le.$toDateUnlimited) {
            form.dateFrom.$setValidity('after', true)
            form.dateTo.$setValidity('earlier', true)
          } else {
            if (form.dateTo.$error && form.dateTo.$error.earlier === true) {
              form.dateTo.$setValidity('earlier', after)
            }
            form.dateFrom.$setValidity('after', after)
          }
        }
      }
      if (field === 'dateTo' || !field) {
        form.dateTo.$setValidity('earlier', true)
        form.dateTo.$setValidity('minDate', true)
        if (!vm.le.$toDateUnlimited) {
          form.dateTo.$setValidity('minDate', minDateEnd)
          if (fromDate && toDate) {
            const earlier = toDate > fromDate
            if (form.dateFrom.$error && form.dateFrom.$error.after === true) {
              form.dateFrom.$setValidity('after', earlier)
            }
            form.dateTo.$setValidity('earlier', earlier)
          }
        } else {
          form.dateFrom.$setValidity('after', true)
          form.dateFrom.$setValidity('earlier', true)
          form.dateTo.$setValidity('after', true)
          form.dateTo.$setValidity('earlier', true)
        }
      }
    }
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/shows.controller:AddLiveEventCtrl
   */
  vm.openFrom = function () {
    vm.dpCfg.fromOpened = true
  }

  /**
   * Handle open "to" datepicker
   *
   * @memberof mwApp/shows.controller:AddLiveEventCtrl
   */
  vm.openTo = function () {
    vm.dpCfg.toOpened = true
  }

  // configurations datepicker for Live Event Date
  /**
   * "From" datepicker settings
   *
   * @memberof mwApp/shows.controller:AddLiveEventCtrl
   */
  vm.dpCfgED = {
    format: 'dd.MM.yyyy',
    minDate: new Date(),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
    changeHandler: function (form, field) {
      if (field) {
        form[field].$setTouched()
      } else {
        form.dateFromED.$setTouched()
        form.dateToED.$setTouched()
      }
      const startDate = vm.le.$startDate && vm.le.$startDate?.setHours(vm.le.$startTime.getHours(), vm.le.$startTime.getMinutes())
      const endDate = vm.le.$endDate && vm.le.$endDate?.setHours(vm.le.$endTime.getHours(), vm.le.$endTime.getMinutes())
      const minDateStart = startDate > formatDateByTimezone(Date.now(), false).valueOf()
      const minDateEnd = endDate > formatDateByTimezone(Date.now(), false).valueOf()
      const maxDateStart = startDate < vm.dpCfgED.maxDate
      const maxDateEnd = endDate < vm.dpCfgED.maxDate
      if (field === 'dateFromED' || !field) {
        form.dateFromED.$setValidity('minDate', minDateStart)
        form.dateFromED.$setValidity('maxDate', maxDateStart)
        form.dateFromED.$setValidity('after', true)

        if (startDate && endDate) {
          const after = endDate > startDate
          if (form.dateToED.$error && form.dateToED.$error.earlier === true) {
            form.dateToED.$setValidity('earlier', after)
          }
          form.dateFromED.$setValidity('after', after)
        }
      }
      if (field === 'dateToED' || !field) {
        form.dateToED.$setValidity('minDate', minDateEnd)
        form.dateToED.$setValidity('maxDate', maxDateEnd)
        form.dateToED.$setValidity('earlier', true)

        if (startDate && endDate) {
          const earlier = endDate > startDate
          if (form.dateFromED.$error && form.dateFromED.$error.after === true) {
            form.dateFromED.$setValidity('after', earlier)
          }
          form.dateToED.$setValidity('earlier', earlier)
        }
      }
    }
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/shows.controller:AddLiveEventCtrl
   */
  vm.openFromED = function () {
    vm.dpCfgED.fromOpened = true
  }

  /**
   * Handle open "to" datepicker
   *
   * @memberof mwApp/shows.controller:AddLiveEventCtrl
   */
  vm.openToED = function () {
    vm.dpCfgED.toOpened = true
  }

  vm.stbUrlAttention = function (url) {
    const webPlatform = vm.platformTypes.find(p => p.value === 'WEB')
    let webPlatformChecked = false
    if (webPlatform) {
      webPlatformChecked = webPlatform.checked
    }
    if (webPlatformChecked) {
      return false
    } else {
      return vm.urlAttention(url)
    }
  }

  vm.urlAttention = function (url) {
    if (url) {
      return url.slice(0, 7) === 'http://'
    } else {
      return false
    }
  }

  vm.stbTrailerUrlAttention = function (url) {
    const webPlatform = vm.platformTypes.find(p => p.name === 'WEB')
    let webTrailerChecked = false
    if (webPlatform) {
      webTrailerChecked = webPlatform.checked && webPlatform.trailerChecked
    }
    if (webTrailerChecked) {
      return false
    } else {
      return vm.trailerUrlAttention(url)
    }
  }

  vm.trailerUrlAttention = function (url) {
    if (url) {
      return url.slice(0, 7) === 'http://'
    } else {
      return false
    }
  }

  /**
   * Change drm profile callback function
   * @param {string} platformName
   * @returns {Function}
   */
  vm.changeDrmProfile = (platformName) => {
    if (!vm.le.urls[platformName].drmProfiles.length) {
      vm.le.urls[platformName].kek = null
    }
  }

  /* Content Sets */

  vm.deleteNetwork = function (network) {
    vm.deselectNetwork(network, vm.form)
    if (vm.le.networks.length) {
      vm.le.contentSets = vm.le.contentSets.filter(cs => cs.networkId !== network.id)
    } else {
      vm.networkSelected = null
    }
    vm.networks = [{ id: 0, name: 'All Organizations' }].concat(vm.networks.filter(n => n.id !== 0).sort((a, b) => {
      return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
    }))
    vm.networks = vm.networks.filter(n => n.id !== -1)
  }

  vm.selectOrganization = function () {
    if (vm.networkSelected.id === 0) {
      vm.networks = [{ id: -1, name: 'Deselect all Organization' }]
      vm.le.networks = angular.copy(vm.listOfNetworks)
    } else if (vm.networkSelected.id === -1) {
      vm.le.networks = []
      vm.networks = [{ id: 0, name: 'All Organizations' }].concat(vm.listOfNetworks)
      vm.networkSelected = null
    } else {
      vm.selectNetwork(vm.networkSelected)
      if (vm.networks.length === 1) {
        vm.networks = [{ id: -1, name: 'Deselect all Organization' }]
      }
    }
  }

  vm.showAllNetworks = false
  vm.showButton = function () {
    const container = document.getElementById('networks-container')
    return container.scrollHeight > 210
  }

  vm.toggleShowAllNetworks = function () {
    vm.showAllNetworks = !vm.showAllNetworks
  }

  vm.changeCatchupEnabled = function () {
    vm.showSimpleCheckbox = vm.le.catchup && !vm.le.catchup.enabled
  }

  vm.formatFullTime = function (date, time) {
    const curDate = new Date(date?.setHours(time.getHours(), time.getMinutes()))
    if (date) {
      return (curDate.getDate() < 10 ? '0' : '') + curDate.getDate() + '.' + (curDate.getMonth() < 9 ? '0' : '') + (curDate.getMonth() + 1) + '.' + curDate.getFullYear() + ' ' + (curDate.getHours() < 10 ? '0' : '') + curDate.getHours() + ':' + (curDate.getMinutes() < 10 ? '0' : '') + curDate.getMinutes()
    }
    return ''
  }

  /**
   * Redirect to previous page
   *
   * @memberof mwApp/packages.controller:AddLiveEventCtrl
   */
  vm.back = function () {
    if (vm.location.canPop()) {
      vm.location.back()
    } else {
      $location.url(vm.le._publicListUrl)
    }
  }

  $scope.infoTemplate = function () {
    const text = 'Please make sure that System TimeZone in Middleware is equal to TimeZone where Live Events will be transmitted. You can check and set System Timezone in '
    const link = '<a href="generalsettings"> General Settings</a>.'
    return text + (authSvc.hasAccess('viewGlobalGeneral') ? link : 'General Settings.')
  }

  $scope.$watch('vm.le.networks.length', (newVal, oldVal) => {
    if (+newVal === 1 && +oldVal === 0) {
      vm.le.contentSets = vm.le.contentSets.filter(cs => cs.networkId === vm.le.networks[0].id)
    }
  })

  $scope.$watch('vm.le.catchup.days', () => {
    if (vm.le.catchup && vm.le.catchup.days) {
      vm.le.$availabilityPeriod = new Date(vm.le.$startDate)
      vm.le.$availabilityPeriod.setDate(vm.le.$availabilityPeriod.getDate() + vm.le.catchup.days)
    } else {
      vm.le.$availabilityPeriod = null
    }
  })

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }

  $timeout(vm.unsetDisable)
}
